module.exports = __webpack_public_path__ + "img/Industry-N55.14341900.jpg";